import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import "./styles.css"
import { Button } from 'reactstrap';
import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
//@ts-ignore
import logo from "../assets/logo.svg"
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useTranslation } from 'react-i18next';
//@ts-ignore
import tr from "../assets/turkish.png"//@ts-ignore
import us from "../assets/us.jpg"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useAppDispatch, useAppSelector } from "../redux/store"
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from '../redux/slices/authSlice';
import MenuIcon from '@mui/icons-material/Menu';
import useWindowSize from '../utils/useWindowSize';


function NavBar() {

    const navigate = useNavigate()
    const location = useLocation()

    const accessToken = useAppSelector(state => state.auth.accessToken)
    const dispatch = useAppDispatch()

    const [width, _] = useWindowSize()

    const { t, i18n } = useTranslation()

    const changeLanguage = (lng: string) => {
        console.log(lng)
        i18n.changeLanguage(lng)
    }

    const handleLogout = () => {
        navigate("/")
        setTimeout(() => {
            dispatch(logout())
        }, 100);

    }

    return (
        <Navbar expand="lg" className="custom-nav" >
            <Container className='d-flex'>
                <CustomNavLink to={"/"}>
                    <Navbar.Brand style={{ color: "#eee", fontSize: "24px", display: "flex", alignItems: "center" }}>
                        <img src={logo} width={30} height={30} />
                        <span className='ms-3' style={{ padding: "0", fontSize: width < 700 ? "22px" : "30px" }}>Ne İş Olsa Yaparım</span>
                    </Navbar.Brand>
                </CustomNavLink>
                <Navbar.Toggle as={"div"} aria-controls="basic-navbar-nav" style={{ color: "#eee" }} ><MenuIcon fontSize="large" className='custom-icon' /></Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav ">
                    <Nav className="" style={{ display: "flex", width: "100%", justifyContent: "end" }}>

                        {accessToken && (
                            <div className='mx-auto d-flex'>
                                <Button className={width < 800 ? "my-auto" : "me-4"} outline color='info' onClick={() => navigate("/create-job")}><AddCircleIcon className='me-2' />İş Ekle</Button>
                            </div>
                        )}

                        <div className={width < 900 ? " menu-div" : "d-flex menu-div"} style={{ marginTop: width < 700 ? "0" : "", alignItems: "center" }}>
                            <h5 className='nav-h5 mx-3 my-auto' onClick={() => navigate("/")} style={{ fontSize: width < 700 ? "16px" : "18px" }}>{t('home')}</h5>
                            <h5 className='nav-h5 mx-3 my-auto' onClick={() => navigate("/about-us")} style={{ fontSize: width < 700 ? "16px" : "18px" }}>{t('aboutUs')}</h5>
                            <h5 className='nav-h5 mx-3 my-auto' onClick={() => navigate("/jobs")} style={{ fontSize: width < 700 ? "16px" : "18px" }}>{t('adds')}</h5>
                        </div>

                        {accessToken ? (
                            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px" }}>
                                <Button className='mx-auto' style={{ maxWidth: width < 800 ? "120px" : "", marginBottom: width < 800 ? "20px" : "" }} onClick={handleLogout} color='danger'>Çıkış Yap<LogoutIcon className='ms-2' style={{ fontSize: "20px" }} /></Button>

                            </div>
                        ) : (
                            <div onClick={() => navigate("/admin-login")} style={{ margin: width < 800 ? "5px 0 20px 0" : "" }}>
                                <AccountCircleIcon className='ms-4 me-4 my-auto admin-login-icon' style={{ color: "#ddd", fontSize: "35px" }} />
                            </div>
                        )}

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "15px" }}>
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    color='dark'
                                    caret
                                >
                                    {i18n.language === "tr" ? <><img className='me-2' src={tr} width={30} height={20} /> Türkçe</> : <><img className='me-2' src={us} width={30} height={20} /> English</>}
                                </DropdownToggle>
                                <DropdownMenu dark>
                                    <DropdownItem onClick={() => changeLanguage("en")}><img className='me-2' src={us} width={30} height={20} />English</DropdownItem>
                                    <DropdownItem onClick={() => changeLanguage("tr")} ><img className='me-2' src={tr} width={30} height={20} />Türkçe</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                        {/* <div className='my-2' style={{ display: "flex", justifyContent: "center" }}>
                            <Button className={'my-auto logout-btn ' + isMobile ? " mx-auto" : " ms-auto"} style={{ maxWidth: isMobile ? "8rem" : "", }} onClick={() => setIsOpen(true)} variant='danger'>Çıkış Yap<i className='ms-2 fa-solid fa-right-from-bracket' /></Button>
                        </div> */}


                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar >
    );
}

const CustomNavLink = ({ to, children }) => {
    const navigate = useNavigate();

    const handleClick = (event) => {
        event.preventDefault();
        navigate(to);
    };

    return (
        <Nav.Link href={to} className='my-2' onClick={handleClick} style={{ color: "#ccc", fontSize: "1.4rem", fontWeight: "500" }}>
            {children}
        </Nav.Link>
    );
};


export default NavBar;